const FILE_EXTENSION_REGEX = /\.\w+$/;
/**
 * Parse out file extension from file name.
 * @param [fileName] File name
 * @returns The file's extension including `.`. E.g: foo.pdf -> `.pdf`.
 */
export function getFileExtension(fileName) {
    if (!fileName) {
        return '';
    }
    const matches = fileName.toLowerCase().match(FILE_EXTENSION_REGEX);
    if (matches) {
        return matches[0];
    }
    return '';
}
/**
 * Given a path to a file, returns the name of the folder containing that
 * file or null if the file is in the root folder or filePath is
 * undefined
 *
 * @param filePath Path to a file
 */
export function getParentFolderFromPath(filePath) {
    if (!filePath) {
        return null;
    }
    const pathComponents = filePath.split('/');
    if (pathComponents.length < 2) {
        return null;
    }
    return pathComponents[pathComponents.length - 2];
}
/**
 * Given a filename, returns the name and extension separately.
 * Doesn't consider dotfiles to have extensions.
 */
export function splitFilename(filename) {
    if (filename === '') {
        return { name: '', ext: '' };
    }
    const splitFilename = filename.split('.');
    const isHiddenFilename = filename.length > 0 && filename[0] === '.';
    let isExtensionlessFilename = filename.indexOf('.') < 0;
    if (isHiddenFilename) {
        // since '.something' is extensionless
        isExtensionlessFilename = splitFilename.length <= 2;
    }
    const fileExtension = splitFilename.pop();
    if (fileExtension && !isExtensionlessFilename) {
        return {
            name: splitFilename.join('.'),
            ext: fileExtension,
        };
    }
    else {
        return {
            name: filename,
            ext: '',
        };
    }
}
export function getFilenameFromPath(path) {
    const pathComponents = path.split('/');
    const filename = pathComponents.pop();
    return filename;
}
//# sourceMappingURL=paths.preenvesnextjs.map
